var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@chakra-ui/react";
export var PrevPageButton = function (_a) {
    var pageClickHandler = _a.pageClickHandler, pageCursor = _a.pageCursor;
    return (_jsx(Button, __assign({ "aria-label": "Previous page", className: "step", onClick: function (event) { return pageClickHandler(event, pageCursor); }, variant: "pagination" }, { children: "\u27E8" })));
};
